import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify, {
  icons: {
    iconfont: "md" //"mdiSvg" // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  }
  // theme: {
  //   themes: {
  //     light: {
  //       primary: "#193bd2",
  //       // secondary: "#424242",
  //       accent: "#0959de",
  //       error: "#bf2626",
  //       success: "#207323",
  //       warning: "#ffb252"
  //     }
  //   }
  // }
});

export default new Vuetify({});
